const handleDeleteFormActions = {
  confirm: 'Do you really want to delete this action?',
  title: 'DELETE ACTION'
};

export default handleDeleteFormActions;
